const { makeStyles } = require("@material-ui/core");

export const useStyles = makeStyles((theme) => ({
  header: {
    color: theme.palette.primary.main,
    margin: 0,
  },
  wrap: {
    backgroundColor: `#fff`,
    backdropFilter: `blur(10px)`,
    top: 0,
    boxShadow: "0 4px 10px -10px rgba(0,0,0,.07)",
  },
  wrapContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // maxWidth: "1260px",
    margin: "0 auto",
    padding: "0px 20px",
  },
  pageInfo: {
    margin: "80px 15px 10px 15px",
    background: "#fff",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  userInfo: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  userBadge: {
    display: "flex",
    alignItems: "center",
    borderRadius: "20px",
    maxHeight: "54px",
    height: "54px",
    cursor: "pointer",
    gap: "3px",
    marginRight: `-10px`,
  },
  email: {
    ...theme.typography.body1,
    paddingRight: 4,
  },
  userData: {
    display: "flex",
    alignItems: "center",
    gap: "3px",
  },
  popperContent: {
    width: 316,
    padding: "24px 15px",
    borderRadius: "10px",
    marginTop: "10px",
    boxShadow: `rgba(50, 50, 93, 0.25) 0px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px`,
    position: "relative",
    right: 16,
  },
  poperHeader: {
    ...theme.typography.h1,
    ...theme.typography.semiBold,
  },
  poperHeaderStatus: {
    ...theme.typography.caption,
  },
  poperSubHeader: {
    ...theme.typography.body1,
  },
  popperInfo: {
    background: "rgb(255, 248, 225)",
    padding: 16,
    borderRadius: 10,
    marginTop: 16,
  },
  popperInfoHeader: {
    ...theme.typography.h6,
    ...theme.typography.semiBold,
  },
  popperInfoLink: {
    ...theme.typography.breadCrumb,
    cursor: "pointer",
    textDecoration: "none",
  },
  divider: {
    margin: `18px 0px`,
    height: "1.5px",
    background: "#e5e7eb",
    width: "100%",
  },
  list: {
    padding: 0,
    listStyleType: "none",
    margin: "-8px",
  },
  listLink: {
    ...theme.typography.body2,
    padding: "8px",
    cursor: "pointer",
    "&:hover": {
      background: `rgb(237 244 255)`,
      borderRadius: 10,
    },
  },
  link: {
    textDecoration: "none",
    color: "inherit",
  },
  userRoutes: {
    display: "flex",
    alignItems: "center",
  },
  routeHeader: {
    ...theme.typography.h6,
    ...theme.typography.semiBold,
    textTransform: "capitalize",
  },
  activeClassName: {
    color: "#1A273A",
    fontWeight: 600,
  },
}));
